import React from 'react';

// Define the type for Material Symbol icons
export type MaterialSymbolIcon = string;

interface MaterialSymbolProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** The name of the icon from Material Symbols */
  icon: MaterialSymbolIcon;

  /** Size in pixels */
  size?: number;
  /** Font weight (100-700) */
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700;
  /** Adjusts the thickness (-25 to 200) */
  grade?: number;
  /** Optimizes for different sizes (20-48) */
  opticalSize?: 20 | 24 | 40 | 48;
  /** Whether to use the filled variation */
  fill?: boolean;
  /** Additional CSS classes */
  className?: string;
}

export function MaterialIcon({
  icon,
  size = undefined,
  weight = 400,
  grade = 0,
  opticalSize = 24,
  fill = false,
  className = '',
  style,
  ...props
}: MaterialSymbolProps): JSX.Element {
  // Validate grade range
  const validGrade = Math.max(-25, Math.min(200, grade));

  const symbolStyle: React.CSSProperties = {
    ...(size && { fontSize: `${size}px` }),
    fontVariationSettings: `
      'FILL' ${fill ? 1 : 0},
      'wght' ${weight},
      'GRAD' ${validGrade},
      'opsz' ${opticalSize}
    `,
    ...style,
  };

  return (
    <span
      className={`material-symbols ${className}`.trim()}
      style={symbolStyle}
      aria-hidden="true"
      {...props}
    >
      {icon}
    </span>
  );
} 